import {mapRunningTime} from '@domain/shared'
import {mapTaskRepetitionDtoToTaskRepetition} from '@hconnect/common/mappers'
import {omit} from 'lodash'
import moment from 'moment-timezone'

import {ShiftEventDto, ShiftEvent} from '../types'
import {isParameterChangeDto, isStoppageDto, isSystemChangeRequestDto, isTaskDto} from '../utils'

// eslint-disable-next-line complexity
export const mapShiftEvent = (response: ShiftEventDto, timezone: string): ShiftEvent => {
  if (!response) return response
  const baseData = {
    created: moment.utc(response.created).tz(timezone),
    lastModified: moment.utc(response.lastModified).tz(timezone),
    lastModifiedStatus: response.lastModifiedStatus
      ? moment.utc(response.lastModifiedStatus).tz(timezone)
      : undefined,
    lastMaintenanceNotificationCreationStart: response.lastMaintenanceNotificationCreationStart
      ? moment.utc(response.lastMaintenanceNotificationCreationStart).tz(timezone)
      : undefined
  }
  if (isStoppageDto(response)) {
    return {
      ...response,
      ...baseData,
      stoppageStart: moment.utc(response.stoppageStart).tz(timezone),
      stoppageEnd: response.stoppageEnd ? moment.utc(response.stoppageEnd).tz(timezone) : undefined,
      pxTrendStoppage:
        response.pxTrendStoppage && mapRunningTime(response.pxTrendStoppage, timezone)
    } as ShiftEvent
  }

  if (isTaskDto(response)) {
    return {
      ...omit(response, ['assignees']),
      ...baseData,
      dueDate: moment.utc(response.dueDate).tz(timezone),
      doNotStartBefore: response.doNotStartBefore
        ? moment.utc(response.doNotStartBefore).tz(timezone)
        : undefined,
      ...('assignees' in response && response.assignees
        ? {assignees: response.assignees}
        : (undefined as never)),
      ...(response.repetitionInfo && {
        repetitionInfo: mapTaskRepetitionDtoToTaskRepetition(response.repetitionInfo, timezone)
      })
    } as ShiftEvent
  }
  if (isSystemChangeRequestDto(response) || isParameterChangeDto(response)) {
    return {
      ...response,
      ...baseData,
      needsApproval: !!response.approvers?.length,
      schedule: response.schedule
        ? {
            startDate: moment.utc(response.schedule.startDate).tz(timezone),
            endDate: moment.utc(response.schedule.endDate).tz(timezone)
          }
        : undefined
    } as ShiftEvent
  }
  return {
    ...response,
    ...baseData,
    schedule: response.schedule
      ? {
          startDate: moment.utc(response.schedule.startDate).tz(timezone),
          endDate: moment.utc(response.schedule.endDate).tz(timezone)
        }
      : undefined
  } as ShiftEvent
}
